interface AuthPageLayoutProps {
  children: React.ReactNode;
}

// TODO [TM]: think about passing header and content separately
const AuthPageLayout: React.FC<AuthPageLayoutProps> = ({ children }) => {
  return (
    <div className="w-full min-h-screen flex flex-col items-center relative background-logo auth-layout">
      {children}
    </div>
  )
}

export default AuthPageLayout
